export const ROLE_OWNER = "owner";
export const ROLE_RECRUITER = "recruiter";
export const ROLE_SUBSCRIBER_CAMPAIGN = "subscriber_campaign";
export const ROLE_SUBSCRIBER_ATS = "subscriber_ats";

export const ALL_CAMPAIGN_ROLES = [
  ROLE_OWNER,
  ROLE_RECRUITER,
  ROLE_SUBSCRIBER_CAMPAIGN,
  ROLE_SUBSCRIBER_ATS
];
export const MANAGERS_ROLES = [ROLE_OWNER, ROLE_RECRUITER];
export const SUBSCRIBERS_ROLES = [ROLE_SUBSCRIBER_CAMPAIGN, ROLE_SUBSCRIBER_ATS];

export const CAMPAIGN_ATS = "applicants";
